import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import EditWarrantyInfoForm from "../form/edit/EditWarrantyInfoForm";
import {Option} from "ts-option";
import Job from "../../../../model/job/Job";

interface IComponentProps {
	/**
	 * On successful edited job callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Job to edit.
	 */
	job: Option<Job>;
}

export default class WarrantyInfoModal extends React.Component<IComponentProps> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={'Warranty information (Worcester Bosh)'}>
				<EditWarrantyInfoForm onSuccess={this.props.onSuccess}
									  onCancel={this.props.onCancel}
									  job={this.props.job}/>
			</Modal>
		);
	};
}